import * as Route from '../support/serverRoutes';
import makeRequest from '../../main/utils/makeRequest';

const elevatedSignupLinks = {
  state: {
    data: [],
    meta: null,
    loading: false,
  },
  reducers: {
    setData(state, { data, meta }) {
      return { ...state, data, meta };
    },
    setLoading(state, isLoading) {
      return { ...state, loading: isLoading };
    },
  },
  effects: (dispatch) => ({
    fetchSignupLinksByEstablishmentId({ establishmentId }) {
      dispatch.elevatedSignupLinks.setLoading(true);
      makeRequest({
        dispatch,
        url: Route.getSignupLinksByEstablishmentId(establishmentId),
        success: (response) => {
          dispatch.elevatedSignupLinks.setData({
            data: response.data.data,
            meta: response.data.meta,
          });
        },
        finish: () => {
          dispatch.elevatedSignupLinks.setLoading(false);
        },
      });
    },
    addEstablishmentSignupLink({ establishmentId, role, after = [] }) {
      makeRequest({
        dispatch,
        url: Route.generateSignupLink(),
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'post',
        data: {
          establishmentId,
          role,
        },
        success: () => {
          dispatch.elevatedSignupLinks.fetchSignupLinksByEstablishmentId({
            establishmentId,
          });
          after.forEach((callback) => callback());
        },
      });
    },
    deleteEstablishmentSignupLink({ id, establishmentId }) {
      makeRequest({
        dispatch,
        url: Route.deleteSignupLink(id),
        method: 'delete',
        success: () => {
          dispatch.elevatedSignupLinks.fetchSignupLinksByEstablishmentId({
            establishmentId,
          });
        },
      });
    },
  }),
};

export default elevatedSignupLinks;
